import React, { useLayoutEffect, useRef } from "react"
import { useWatchVariations, mvSubscribe } from "./../context"

export function Loader({ ctx, size }) {
  const { gready } = useWatchVariations(ctx)
  const rfmain = useRef(null)

  function onGready(v) {
    rfmain.current?.classList[!v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("Loader gready", gready, onGready), [])

  return (
    <svg ref={rfmain} xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'>
      {[
        {
          rotate: "rotate(0 50 50)",
          begin: "-0.9166666666666666s",
        },
        {
          rotate: "rotate(30 50 50)",
          begin: "-0.8333333333333334s",
        },
        {
          rotate: "rotate(60 50 50)",
          begin: "-0.75s",
        },
        {
          rotate: "rotate(90 50 50)",
          begin: "-0.6666666666666666s",
        },
        {
          rotate: "rotate(120 50 50)",
          begin: "-0.5833333333333334s",
        },
        {
          rotate: "rotate(150 50 50)",
          begin: "-0.5s",
        },
        {
          rotate: "rotate(180 50 50)",
          begin: "-0.4166666666666667s",
        },
        {
          rotate: "rotate(210 50 50)",
          begin: "-0.3333333333333333s",
        },
        {
          rotate: "rotate(240 50 50)",
          begin: "-0.25s",
        },
        {
          rotate: "rotate(270 50 50)",
          begin: "-0.16666666666666666s",
        },
        {
          rotate: "rotate(300 50 50)",
          begin: "-0.08333333333333333s",
        },
        {
          rotate: "rotate(330 50 50)",
          begin: "0s",
        },
      ].map(({ rotate, begin }, index) => (
        <g transform={rotate} key={index}>
          <rect x='46' y='2.5' rx='9.200000000000001' ry='0.5' width='8' height='15'>
            <animate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin={begin} repeatCount='indefinite' />
          </rect>
        </g>
      ))}
    </svg>
  )
}
